import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.757 6.713 C 9.687 6.739,9.574 6.799,9.507 6.846 C 9.439 6.893,8.249 8.068,6.862 9.457 C 5.112 11.211,4.317 12.029,4.263 12.133 C 4.108 12.434,4.175 12.832,4.421 13.079 C 4.668 13.325,5.066 13.392,5.367 13.237 C 5.470 13.184,6.211 12.466,7.758 10.922 L 10.000 8.684 12.242 10.922 C 13.789 12.466,14.530 13.184,14.633 13.237 C 14.934 13.392,15.332 13.325,15.579 13.079 C 15.825 12.832,15.892 12.435,15.737 12.133 C 15.629 11.922,10.576 6.869,10.371 6.767 C 10.185 6.674,9.922 6.651,9.757 6.713 ",
		stroke: "none",
		fillRule: "evenodd",
		fill: "currentColor"
	})
});
export default SvgCaretSmall;
